import kamala from '../../kamala'
import ResizeAware from './ResizeAware'

ResizeAware.install = function (Vue) {
  kamala(Vue)
  Vue.component(ResizeAware.name, ResizeAware)
}

export default ResizeAware
